import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get country
export const getCountry = createAsyncThunk("country/getCountry", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCountry({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all country
export const getAllCountry = createAsyncThunk("country/getAllCountry", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCountry();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("country/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("country/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("country/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageCountry({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get particular page
export const getCountryById = createAsyncThunk("country/getCountryById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getCountryById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create country
export const createCountry = createAsyncThunk("country/createCountry", async (param, { rejectWithValue }) => {
  try {
    const body = new FormData();

    Object.entries(param).forEach(([key, value]) => {
      {
        body.append(key, value);
      }
    });
    const { data } = await API.createCountry(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

export const updateCountry = createAsyncThunk("country/updateCountry", async (param, { rejectWithValue }) => {
  const { id, values } = param;

  try {
    const body = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      {
        body.append(key, value);
      }
    });
    const { data } = await API.updateCountry(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("country/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
